
import { defineComponent } from "vue";
import { BDropdown } from "bootstrap-vue";
import { IDropdownItem } from "@/types";

export default defineComponent({
  name: "GDropdown",
  components: {
    FlexibleText: () => import("@/components/shared/FlexibleText.vue"),
  },
  props: {
    items: {
      required: true,
      type: Array as () => IDropdownItem<any>[],
    },
    placeholder: {
      type: String,
      default: "",
    },
    flexibleWidth: {
      type: Boolean,
      default: false,
    },
    tooltipText: {
      type: String,
      default: "",
    },
    value: undefined as any,
  },
  computed: {
    dropdownStyle(): any {
      return {
        height: Math.min(this.items.length, 8) * 34 + "px",
        marginBottom: "-2px",
      };
    },
  },
  methods: {
    selectItem(item: IDropdownItem<any>) {
      this.$emit("input", item.value);
      this.$emit("itemSelected", item.value);
      this.close();
    },
    open(): void {
      const dd = this.$refs.BDropdown as BDropdown;
      dd.show();
    },
    close(): void {
      const dd = this.$refs.BDropdown as BDropdown;
      dd.hide();
    },
  },
});
